/*eslint-disable */
import { Fragment, useState, useEffect } from 'react'

const themeConfigForex = {
  app: {
    appName: 'Forex Comparator',
    appLogoImage: require('@src/assets/images/logo/logo.svg').default,
    type: 'Forex'
  },
  layout: {
    isRTL: false,
    skin: 'dark', // light, dark, bordered, semi-dark
    routerTransition: 'tada', // fadeIn, fadeInLeft, zoomIn, none or check this for more transition https://animate.style/
    type: 'vertical', // vertical, horizontal
    contentWidth: 'full', // full, boxed
    menu: {
      isHidden: true,
      isCollapsed: false
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: 'hidden', // static , sticky , floating, hidden
      backgroundColor: 'white' // BS color options [primary, success, etc]
    },
    footer: {
      type: 'static' // static, sticky, hidden
    },
    customizer: true,
    scrollTop: true // Enable scroll to top button
  },
  header: {
    headerText: '74-89% of retail investor accounts lose money when trading CFDs with this provider.',
    headerText2: 'You should consider whether you understand how CFDs work and whether you can afford to take the high risk of losing your money.',
    headerText3: 'CFDs are complex instruments and come with a high risk of losing money rapidly due to leverage. '
  },
  footer: {
    rigthText1: 'Prima di continuare fai attenzione. Il 79.9% degli account di investitori al dettaglio perde denaro nel trading di CFD',
    rigthText2: "Considera le tue conoscenze sul funzionamento dei CFD e se puoi permetterti l'alta probabilità di perdere i tuoi soldi.",
    footerBanner: false,
    Faqs: {
      initial: {
        title: 'Privacy & Cookies',
        link: '/faq/Privacy'
      },
      middle: {
        title: 'Disclaimer',
        link: '/faq/Disclaimer'
      },
      last: {
        title: 'Rischio',
        link: '/faq/Rischio'
      }
    },
    faqData: {
      // payment
      privacy: {
        icon: 'AlertCircle',
        title: 'Privacy',
        subtitle: 'Privacy & Cookies',
        qandA: [
          {
            question: 'Privacy Policy',
            ans: " Da " + process.env.REACT_APP_MARCA_BLANCA_DOMAIN + " puntiamo sul valore della privacy, sicurezza e affidabilità non soltanto nelle nostre recensioni dei concessionari di gioco ma anche all'interno del sito che mettiamo a disposizione dei visitatori. Abbiamo creato questa pagina con l'informativa sulla privacy per rendervi consapevoli di come i dati da voi forniti vengano trattati, di come "+ process.env.REACT_APP_MARCA_BLANCA_DOMAIN +" garantisca la tutela della privacy dell'utente e sul funzionamento generale del nostro sito. Con l'uso del nostro prodotto, concordi alle seguenti disposizioni e condizioni d'uso"
          },
          {
            question: '  Finalità del trattamento',
            ans: 'Il sito web e il servizio ' + process.env.REACT_APP_MARCA_BLANCA_DOMAIN + '  possono essere utilizzati senza registrazione, pertanto gli unici dati raccolti sono quelli di Google Analytics. I dati raccolti vengono utilizzati per migliorare il prodotto disponibile su ' + process.env.REACT_APP_MARCA_BLANCA_DOMAIN
          },
          {
            question: 'Definizioni',
            ans:
              <ul>
                <li>{'Prodotto: Il prodotto è il sito web ' + process.env.REACT_APP_MARCA_BLANCA_DOMAIN}</li>
                <li>Dati personali: i dati personali comprendono l'indirizzo e-mail fornito volontariamente.</li>
                <li>Dati dell'utente: i dati dell'utente sono quelli raccolti automaticamente con l'uso del nostro prodotto, come il tempo trascorso sul sito o il numero di pagine visitate.</li>
              </ul>
          },
          {
            question: 'Metodo di lavorazione',
            ans: ' I dati raccolti vengono trattati con la massima riservatezza, utilizzando misure di sicurezza informatica che ne impediscono la visione da parte di fonti esterne. Si precisa inoltre che i dati forniti non saranno diffusi o comunicati a società esterne.'
          },
          {
            question: 'Utilizzo dei cookie',
            ans: "Utilizziamo i cookie al solo scopo di analizzare i dati degli utenti raccolti tramite Google Analytics. Questi dati dell'utente ci permettono di migliorare il nostro servizio per la vostra prossima visita."
          },
          {
            question: 'Titolare del trattamento dei dati',
            ans: process.env.REACT_APP_MARCA_BLANCA_DOMAIN
          }
        ]
      },
      // delivery
      responsability: {
        icon: 'UserCheck',
        title: 'Disclaimer',
        subtitle: 'Disclaimer Important',
        qandA: [
          {
            question: 'DISCLAIMER IMPORTANTE',
            ans: "Il contenuto fornito su questo sito web include notizie generiche e pubblicazioni, le nostre analisi, opinioni personali e contenuti forniti da terze parti, che sono intesi solo per scopi di istruzione e ricerca. Non costituisce e non dovrebbe essere letto come raccomandazione o consiglio a intraprendere qualsiasi azione, inclusi investimenti o acquisti di qualsiasi prodotto. Prima di prendere qualsiasi decisione finanziaria, dovresti effettuare le tue proprie valutazioni, applicare la tua discrezione e consultare solo i soggetti competenti di tua fiducia. Il contenuto del sito web non risulta diretto personalmente a te e noi non possiamo tenere in considerazione la tua situazione finanziaria e i tuoi bisogni. Le informazioni contenute in questo sito non sono necessariamente fornite in tempo reale né risultano necessariamente accurate. I prezzi qui riportati potrebbero essere forniti da market makers e non dalle borse. Qualsiasi operazione di trading o altra decisione finanziaria che farai ricadrà sotto la tua piena responsabilità e non dovresti affidarti completamente a nessuna informazione fornita in tutto il sito. Forexcomparator non offre nessuna garanzia riguardante le informazioni contenute nel sito e non si può assumere alcuna responsabilità per qualsiasi perdita finanziaria di trading che puoi patire per esserti affidato a qualsiasi informazione contenuta in questo sito. Il sito web può includere pubblicità e altri contenuti promozionali e Forexcomparator può ricevere un compenso da terze parti in relazione al contenuto. Forexcomparator nono appoggia le terze parti, non raccomanda l'utilizzo di alcun servizio e non si assume la responsabilità per qualsiasi utilizzo di servizi o siti web forniti da terze parti. Forexcomparator e i suoi dipendenti, agenti, filiali e associati non sono responsabili e non dovrebbero essere ritenuti tali per alcuna perdita o danno risultante dal tuo utilizzo del sito o dal tuo affidamento sulle informazioni fornite su questo sito."
          }

        ]
      },
      // cancellation and return
      disclaimer: {
        icon: 'Tag',
        title: 'Rischio',
        subtitle: 'Disclaimer RISCHIO',
        qandA: [
          {
            question: 'DISCLAIMERS DI RISCHIO',
            ans:
              <Fragment>
                <p>Questo sito include informazioni sulle criptovalute, contratti differenziali (CFDs) e altri strumenti finanziari, e sui brokers, le borse e altre entità che effettuano trading in questi strumenti.
                </p>
                <p>Sia le criptovalute che i CFD sono strumenti complessi e presentano un elevato rischio di perdere il proprio capitale. Dovresti considerare attentamente se comprendi il funzionamento di questi strumenti e se puoi permetterti di sostenere il rischio elevato di perdere il tuo denaro. Forexcomparator ti incoraggia a effettuare le tue ricerche personali prima di effettuare qualsiasi decisione d'investimento, e di evitare di investire in qualsiasi strumento finanziario di cui tu non abbia una comprensione completa sul funzionamento e sui suoi rischi.</p>
              </Fragment>
          }
        ]
      }

    }

  },
  navBar:false,
}

const themeConfigGambling = {
  app: {
    appName: process.env.REACT_APP_MARCA_BLANCA,
    appLogoImage: require('@src/assets/images/logo/logo.svg').default,
    type: 'Gambling'
  },
  layout: {
    isRTL: false,
    skin: 'light', // light, dark, bordered, semi-dark
    routerTransition: 'pulse', // fadeIn, fadeInLeft, zoomIn, none or check this for more transition https://animate.style/
    type: 'vertical', // vertical, horizontal
    contentWidth: 'full', // full, boxed
    menu: {
      isHidden: true,
      isCollapsed: false
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: 'hidden', // static , sticky , floating, hidden
      backgroundColor: 'white' // BS color options [primary, success, etc]
    },
    footer: {
      type: 'static' // static, sticky, hidden
    },
    customizer: false,
    scrollTop: true // Enable scroll to top button
  },
  header: {
    headerText: 'Ecco il tuo comparatore bonus definitivo e aggiornato.',
    headerText2: 'Confrontiamo i bonus di benvenuto dei vari operatori di gioco online con regolare licenza aams.',
    headerText3: 'Oltre ai bonus è possibile trovare altre informazioni per conoscere meglio la sala e scegliere cosi tra una vasta offerta di possibilitá.'
  },
  footer: {
    rigthText: 'Il gioco può causare dipendenza patologica | Gioca Responsabilmente | © Ltd 2021',
    footerBanner: false,
    Faqs: {
      initial: {
        title: 'Privacy & Cookies',
        link: '/faq/Privacy'
      },
      middle: {
        title: 'Gioco Responsabile',
        link: '/faq/Responsabile'
      },
      last: {
        title: 'Disclaimer',
        link: '/faq/Disclaimer'
      }
    },
    faqData: {
      // payment
      privacy: {
        icon: 'AlertCircle',
        title: 'Privacy',
        subtitle: 'Privacy & Cookies',
        qandA: [
          {
            question: 'Privacy Policy',
            ans: " Da " + process.env.REACT_APP_MARCA_BLANCA_DOMAIN + " puntiamo sul valore della privacy, sicurezza e affidabilità non soltanto nelle nostre recensioni dei concessionari di gioco ma anche all'interno del sito che mettiamo a disposizione dei visitatori. Abbiamo creato questa pagina con l'informativa sulla privacy per rendervi consapevoli di come i dati da voi forniti vengano trattati, di come " + process.env.REACT_APP_MARCA_BLANCA_DOMAIN + " garantisca la tutela della privacy dell'utente e sul funzionamento generale del nostro sito. Con l'uso del nostro prodotto, concordi alle seguenti disposizioni e condizioni d'uso"
          },
          {
            question: '  Finalità del trattamento',
            ans: 'Il sito web e il servizio ' + process.env.REACT_APP_MARCA_BLANCA_DOMAIN + '  possono essere utilizzati senza registrazione, pertanto gli unici dati raccolti sono quelli di Google Analytics. I dati raccolti vengono utilizzati per migliorare il prodotto disponibile su ' + process.env.REACT_APP_MARCA_BLANCA_DOMAIN + '.'
          },
          {
            question: 'Definizioni',
            ans:
              <ul>
                <li>{'Prodotto: Il prodotto è il sito web ' + process.env.REACT_APP_MARCA_BLANCA_DOMAIN}</li>
                <li>Dati personali: i dati personali comprendono l'indirizzo e-mail fornito volontariamente.</li>
                <li>Dati dell'utente: i dati dell'utente sono quelli raccolti automaticamente con l'uso del nostro prodotto, come il tempo trascorso sul sito o il numero di pagine visitate.</li>
              </ul>
          },
          {
            question: 'Metodo di lavorazione',
            ans: ' I dati raccolti vengono trattati con la massima riservatezza, utilizzando misure di sicurezza informatica che ne impediscono la visione da parte di fonti esterne. Si precisa inoltre che i dati forniti non saranno diffusi o comunicati a società esterne.'
          },
          {
            question: 'Utilizzo dei cookie',
            ans: "Utilizziamo i cookie al solo scopo di analizzare i dati degli utenti raccolti tramite Google Analytics. Questi dati dell'utente ci permettono di migliorare il nostro servizio per la vostra prossima visita."
          },
          {
            question: 'Titolare del trattamento dei dati',
            ans: process.env.REACT_APP_MARCA_BLANCA_DOMAIN
          }
        ]
      },
      // delivery
      responsability: {
        icon: 'UserCheck',
        title: 'Responsabile',
        subtitle: 'Gioco Responsabile',
        qandA: [
          {
            question: 'Cosa sono le scommesse?',
            ans: " Scommettere online è un passatempo sempre più diffuso, anche grazie agli smartphone  che semplificano l’accesso ai bookmaker. Il Gioco però comporta dei rischi di perdite di denaro, per cui è molto importante che gli utenti che amano scommettere lo facciano in maniera consapevole e responsabile, senza esagerare."
          },
          {
            question: "Come sosteniamo il gioco d'azzardo responsabile?",
            ans: process.env.REACT_APP_MARCA_BLANCA_DOMAIN + "il gioco responsabile, invitando i nostri utenti a giocare con moderazione solo ed esclusivamente su siti scommesse ADM, gli unici in grado di garantire un elevato livello di protezione del giocatore. Alle volte l’abuso può trasformarsi in una dipendenza da gioco d’azzardo, con gravi ripercussioni su salute, affetti e vita professionale, e per questo è importante intervenire tempestivamente. "
          },
          {
            question: "Quando bisogna preoccuparsi?",
            ans: "La ludopatia è un desiderio incontrollabile di giocare e scommettere, senza pensare ad alcune ripercussioni negative sulla salute della persona. Non solo: essa può portare anche problemi dal punto di vista delle finanze, dei rapporti lavorativi e interpersonali."
          },
          {
            question: "Quali comportamenti può avere una persona affetta da disturbo da gioco d'azzardo patologico?",
            ans:
              <Fragment>
                <span>Secondo le indicazioni dell’Organizzazione Mondiale della Sanità. Ecco i sintomi tipici di una dipendenza come la ludopatia:</span>
                <ul>
                  <li>Pensare al gioco d’azzardo in modo ossessivo.</li>
                  <li>Ricerca dell’”adrenalina della vittoria” alzando sempre l’asticella.</li>
                  <li>Desiderio del gioco impossibile da reprimere.</li>
                  <li>Quando non si gioca ci si sente stressati o irrequieti.</li>
                  <li>Vedere le scommesse o il gioco come una soluzione dei problemi.</li>
                  <li>Giocare al di sopra delle proprie possibilità finanziarie per recuperare il denaro perso.</li>
                  <li>Procurarsi il denaro necessario rubando o commettendo altri atti illeciti.</li>
                  <li>Rischiare il proprio lavoro o gli affetti per il gioco o le scommesse.</li>
                  <li>Chiedere prestiti di denaro a conoscenti o amici per giocare.</li>
                  <li>Non essere sinceri con familiari e amici riguardo il problema.</li>
                  <li>Impostare dei Limiti di Gioco.</li>
                </ul>
              </Fragment>
          },
          {
            question: 'Che soluzione posso adottare?',
            ans: "Una soluzione per controllare i propri comportamenti ed evitare che essi possano degenerare è di certo quello di imporsi dei limiti di spesa. Questo tipo di precauzione può essere presa dall’utente già in fase di registrazione ad una piattaforma di gioco online, in quanto nel form di registrazione c’è sempre questa opzione sui limiti di gioco. A cosa serve? Questo metodo può dare all’utente un limite di budget settimanale o mensile di ricarica sul proprio conto online. Per fare un esempio: se si imposta un limite di ricarica di 1000€ al mese, sarà lo stesso bookmaker ADM (ex AAMS) ad impedire al giocatore versamenti che vadano oltre quel limite mensile sull’account di gioco personale. Questi limiti di gioco da impostare in fase di registrazione, inoltre, possono essere modificati anche successivamente all’iscrizione grazie a delle opzioni presenti sul proprio account online."
          },
          {
            question: "Prendersi un periodo di pausa: l’auto-esclusione",
            ans: "Altra soluzione che può utilizzare un utente che crede di aver bisogno di limitare il proprio gioco d’azzardo è quella dell’auto-esclusione. Questo strumento è presente in tutti i bookmakers online ed è grazie ad esso che l’utente può mettere in pausa il proprio conto gioco online. Questo tipo di funzione dell’auto-esclusione, inoltre, se viene attivata ha effetto su tutte le piattaforme di scommesse ADM: per quell’utente, dunque, sarà impossibile anche aprire un nuovo gioco su un altro sito di scommesse ADM. Questo strumento di auto-esclusione può essere attivato in due modalità: tempo determinato, per un numero di giorni che l’utente stabilirà fino ad un massimo di 90, oppure a tempo indeterminato, minimo 6 mesi. In questo periodo di pausa, dunque, l’utente: può accedere al proprio conto gioco online e ritirare l’eventuale denaro presente non può ricaricare il proprio account con versamente né scommettere Una volta attivato il metodo di auto-esclusione a tempo determinato, esso si conclude automaticamente una volta passato il tempo scelto dall’utente. Se si imposta una esclusione a tempo indeterminato, invece, solo dopo almeno 6 mesi si può riattivare il proprio conto gioco con tutte le sue funzioni, dopo aver inviato una comunicazione alla piattaforma online. Se si è scelta questa modalità di auto-esclusione a tempo indeterminato, bisognerà fare molta attenzione ad essere ben pronti quando si ritorna ad attivare il proprio conto gioco."
          },
          {
            question: 'Che soluzione posso adottare?',
            ans: "Una soluzione per controllare i propri comportamenti ed evitare che essi possano degenerare è di certo quello di imporsi dei limiti di spesa. Questo tipo di precauzione può essere presa dall’utente già in fase di registrazione ad una piattaforma di gioco online, in quanto nel form di registrazione c’è sempre questa opzione sui limiti di gioco. A cosa serve? Questo metodo può dare all’utente un limite di budget settimanale o mensile di ricarica sul proprio conto online. Per fare un esempio: se si imposta un limite di ricarica di 1000€ al mese, sarà lo stesso bookmaker ADM (ex AAMS) ad impedire al giocatore versamenti che vadano oltre quel limite mensile sull’account di gioco personale. Questi limiti di gioco da impostare in fase di registrazione, inoltre, possono essere modificati anche successivamente all’iscrizione grazie a delle opzioni presenti sul proprio account online."
          },
        ]
      },
      // cancellation and return
      disclaimer: {
        icon: 'Tag',
        title: 'Disclaimer',
        subtitle: 'Disclaimer',
        qandA: [
          {
            question: ' Il sito ' + process.env.REACT_APP_MARCA_BLANCA_DOMAIN + ' non è una testata giornalistica',
            ans:
              <Fragment>
                <p> {'Il sito ' + process.env.REACT_APP_MARCA_BLANCA_DOMAIN + ' non è una testata giornalistica in quanto viene aggiornato senza alcuna regolarità. Non può quindi considerarsi un prodotto editoriale ai sensi della legge n° 62 del 7.03.2001.'}
                </p>
                <p>   Lo scopo del sito è quello di fornire informazioni sulle migliori slot online. Inoltre, verifichiamo la sicurezza e l’affidabilità dei Bookmaker Online ADM. Il tutto attraverso un’analisi comparativa delle offerte bonus degli operatori.</p>
                <p>Puoi giocare d’azzardo solo se hai compiuto 18 anni.
                  Il gioco può causare dipendenza patologica.</p>
              </Fragment>
          }
        ]
      }

    }

  },
  navBar:false
}

const themeConfigGamblingDeally = {
  app: {
    appName: process.env.REACT_APP_MARCA_BLANCA,
    appLogoImage: require('@src/assets/images/logo/logo.svg').default,
    type: 'Gambling'
  },
  layout: {
    isRTL: false,
    skin: 'light', // light, dark, bordered, semi-dark
    routerTransition: 'pulse', // fadeIn, fadeInLeft, zoomIn, none or check this for more transition https://animate.style/
    type: 'vertical', // vertical, horizontal
    contentWidth: 'full', // full, boxed
    menu: {
      isHidden: true,
      isCollapsed: false
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: 'hidden', // static , sticky , floating, hidden
      backgroundColor: 'white' // BS color options [primary, success, etc]
    },
    footer: {
      type: 'static' // static, sticky, hidden
    },
    customizer: false,
    scrollTop: true // Enable scroll to top button
  },
  header: {
    headerText: 'Ecco il tuo comparatore bonus definitivo e aggiornato.',
    headerText2: 'Confrontiamo i bonus di benvenuto dei vari operatori di gioco online con regolare licenza aams.',
    headerText3: 'Oltre ai bonus è possibile trovare altre informazioni per conoscere meglio la sala e scegliere cosi tra una vasta offerta di possibilitá.'
  },
  footer: {
    rigthText: 'Il gioco può causare dipendenza patologica | Gioca Responsabilmente | © Ltd 2021',
    footerBanner: false,
    Faqs: {
      initial: {
        title: 'Privacy & Cookies',
        link: '/faq/Privacy'
      },
      middle: {
        title: 'Gioco Responsabile',
        link: '/faq/Responsabile'
      },
      last: {
        title: 'Disclaimer',
        link: '/faq/Disclaimer'
      }
    },
    faqData: {
      // payment
      privacy: {
        icon: 'AlertCircle',
        title: 'Privacy',
        subtitle: 'Privacy & Cookies',
        qandA: [
          {
            question: 'Privacy Policy',
            ans: " Da " + process.env.REACT_APP_MARCA_BLANCA_DOMAIN + " puntiamo sul valore della privacy, sicurezza e affidabilità non soltanto nelle nostre recensioni dei concessionari di gioco ma anche all'interno del sito che mettiamo a disposizione dei visitatori. Abbiamo creato questa pagina con l'informativa sulla privacy per rendervi consapevoli di come i dati da voi forniti vengano trattati, di come " + process.env.REACT_APP_MARCA_BLANCA_DOMAIN + " garantisca la tutela della privacy dell'utente e sul funzionamento generale del nostro sito. Con l'uso del nostro prodotto, concordi alle seguenti disposizioni e condizioni d'uso"
          },
          {
            question: '  Finalità del trattamento',
            ans: 'Il sito web e il servizio ' + process.env.REACT_APP_MARCA_BLANCA_DOMAIN + '  possono essere utilizzati senza registrazione, pertanto gli unici dati raccolti sono quelli di Google Analytics. I dati raccolti vengono utilizzati per migliorare il prodotto disponibile su ' + process.env.REACT_APP_MARCA_BLANCA_DOMAIN + '.'
          },
          {
            question: 'Definizioni',
            ans:
              <ul>
                <li>{'Prodotto: Il prodotto è il sito web ' + process.env.REACT_APP_MARCA_BLANCA_DOMAIN}</li>
                <li>Dati personali: i dati personali comprendono l'indirizzo e-mail fornito volontariamente.</li>
                <li>Dati dell'utente: i dati dell'utente sono quelli raccolti automaticamente con l'uso del nostro prodotto, come il tempo trascorso sul sito o il numero di pagine visitate.</li>
              </ul>
          },
          {
            question: 'Metodo di lavorazione',
            ans: ' I dati raccolti vengono trattati con la massima riservatezza, utilizzando misure di sicurezza informatica che ne impediscono la visione da parte di fonti esterne. Si precisa inoltre che i dati forniti non saranno diffusi o comunicati a società esterne.'
          },
          {
            question: 'Utilizzo dei cookie',
            ans: "Utilizziamo i cookie al solo scopo di analizzare i dati degli utenti raccolti tramite Google Analytics. Questi dati dell'utente ci permettono di migliorare il nostro servizio per la vostra prossima visita."
          },
          {
            question: 'Titolare del trattamento dei dati',
            ans: process.env.REACT_APP_MARCA_BLANCA_DOMAIN
          }
        ]
      },
      // delivery
      responsability: {
        icon: 'UserCheck',
        title: 'Responsabile',
        subtitle: 'Gioco Responsabile',
        qandA: [
          {
            question: 'Cosa sono le scommesse?',
            ans: " Scommettere online è un passatempo sempre più diffuso, anche grazie agli smartphone  che semplificano l’accesso ai bookmaker. Il Gioco però comporta dei rischi di perdite di denaro, per cui è molto importante che gli utenti che amano scommettere lo facciano in maniera consapevole e responsabile, senza esagerare."
          },
          {
            question: "Come sosteniamo il gioco d'azzardo responsabile?",
            ans: process.env.REACT_APP_MARCA_BLANCA_DOMAIN + "il gioco responsabile, invitando i nostri utenti a giocare con moderazione solo ed esclusivamente su siti scommesse ADM, gli unici in grado di garantire un elevato livello di protezione del giocatore. Alle volte l’abuso può trasformarsi in una dipendenza da gioco d’azzardo, con gravi ripercussioni su salute, affetti e vita professionale, e per questo è importante intervenire tempestivamente. "
          },
          {
            question: "Quando bisogna preoccuparsi?",
            ans: "La ludopatia è un desiderio incontrollabile di giocare e scommettere, senza pensare ad alcune ripercussioni negative sulla salute della persona. Non solo: essa può portare anche problemi dal punto di vista delle finanze, dei rapporti lavorativi e interpersonali."
          },
          {
            question: "Quali comportamenti può avere una persona affetta da disturbo da gioco d'azzardo patologico?",
            ans:
              <Fragment>
                <span>Secondo le indicazioni dell’Organizzazione Mondiale della Sanità. Ecco i sintomi tipici di una dipendenza come la ludopatia:</span>
                <ul>
                  <li>Pensare al gioco d’azzardo in modo ossessivo.</li>
                  <li>Ricerca dell’”adrenalina della vittoria” alzando sempre l’asticella.</li>
                  <li>Desiderio del gioco impossibile da reprimere.</li>
                  <li>Quando non si gioca ci si sente stressati o irrequieti.</li>
                  <li>Vedere le scommesse o il gioco come una soluzione dei problemi.</li>
                  <li>Giocare al di sopra delle proprie possibilità finanziarie per recuperare il denaro perso.</li>
                  <li>Procurarsi il denaro necessario rubando o commettendo altri atti illeciti.</li>
                  <li>Rischiare il proprio lavoro o gli affetti per il gioco o le scommesse.</li>
                  <li>Chiedere prestiti di denaro a conoscenti o amici per giocare.</li>
                  <li>Non essere sinceri con familiari e amici riguardo il problema.</li>
                  <li>Impostare dei Limiti di Gioco.</li>
                </ul>
              </Fragment>
          },
          {
            question: 'Che soluzione posso adottare?',
            ans: "Una soluzione per controllare i propri comportamenti ed evitare che essi possano degenerare è di certo quello di imporsi dei limiti di spesa. Questo tipo di precauzione può essere presa dall’utente già in fase di registrazione ad una piattaforma di gioco online, in quanto nel form di registrazione c’è sempre questa opzione sui limiti di gioco. A cosa serve? Questo metodo può dare all’utente un limite di budget settimanale o mensile di ricarica sul proprio conto online. Per fare un esempio: se si imposta un limite di ricarica di 1000€ al mese, sarà lo stesso bookmaker ADM (ex AAMS) ad impedire al giocatore versamenti che vadano oltre quel limite mensile sull’account di gioco personale. Questi limiti di gioco da impostare in fase di registrazione, inoltre, possono essere modificati anche successivamente all’iscrizione grazie a delle opzioni presenti sul proprio account online."
          },
          {
            question: "Prendersi un periodo di pausa: l’auto-esclusione",
            ans: "Altra soluzione che può utilizzare un utente che crede di aver bisogno di limitare il proprio gioco d’azzardo è quella dell’auto-esclusione. Questo strumento è presente in tutti i bookmakers online ed è grazie ad esso che l’utente può mettere in pausa il proprio conto gioco online. Questo tipo di funzione dell’auto-esclusione, inoltre, se viene attivata ha effetto su tutte le piattaforme di scommesse ADM: per quell’utente, dunque, sarà impossibile anche aprire un nuovo gioco su un altro sito di scommesse ADM. Questo strumento di auto-esclusione può essere attivato in due modalità: tempo determinato, per un numero di giorni che l’utente stabilirà fino ad un massimo di 90, oppure a tempo indeterminato, minimo 6 mesi. In questo periodo di pausa, dunque, l’utente: può accedere al proprio conto gioco online e ritirare l’eventuale denaro presente non può ricaricare il proprio account con versamente né scommettere Una volta attivato il metodo di auto-esclusione a tempo determinato, esso si conclude automaticamente una volta passato il tempo scelto dall’utente. Se si imposta una esclusione a tempo indeterminato, invece, solo dopo almeno 6 mesi si può riattivare il proprio conto gioco con tutte le sue funzioni, dopo aver inviato una comunicazione alla piattaforma online. Se si è scelta questa modalità di auto-esclusione a tempo indeterminato, bisognerà fare molta attenzione ad essere ben pronti quando si ritorna ad attivare il proprio conto gioco."
          },
          {
            question: 'Che soluzione posso adottare?',
            ans: "Una soluzione per controllare i propri comportamenti ed evitare che essi possano degenerare è di certo quello di imporsi dei limiti di spesa. Questo tipo di precauzione può essere presa dall’utente già in fase di registrazione ad una piattaforma di gioco online, in quanto nel form di registrazione c’è sempre questa opzione sui limiti di gioco. A cosa serve? Questo metodo può dare all’utente un limite di budget settimanale o mensile di ricarica sul proprio conto online. Per fare un esempio: se si imposta un limite di ricarica di 1000€ al mese, sarà lo stesso bookmaker ADM (ex AAMS) ad impedire al giocatore versamenti che vadano oltre quel limite mensile sull’account di gioco personale. Questi limiti di gioco da impostare in fase di registrazione, inoltre, possono essere modificati anche successivamente all’iscrizione grazie a delle opzioni presenti sul proprio account online."
          },
        ]
      },
      // cancellation and return
      disclaimer: {
        icon: 'Tag',
        title: 'Disclaimer',
        subtitle: 'Disclaimer',
        qandA: [
          {
            question: ' Il sito ' + process.env.REACT_APP_MARCA_BLANCA_DOMAIN + ' non è una testata giornalistica',
            ans:
              <Fragment>
                <p> {'Il sito ' + process.env.REACT_APP_MARCA_BLANCA_DOMAIN + ' non è una testata giornalistica in quanto viene aggiornato senza alcuna regolarità. Non può quindi considerarsi un prodotto editoriale ai sensi della legge n° 62 del 7.03.2001.'}
                </p>
                <p>   Lo scopo del sito è quello di fornire informazioni sulle migliori slot online. Inoltre, verifichiamo la sicurezza e l’affidabilità dei Bookmaker Online ADM. Il tutto attraverso un’analisi comparativa delle offerte bonus degli operatori.</p>
                <p>Puoi giocare d’azzardo solo se hai compiuto 18 anni.
                  Il gioco può causare dipendenza patologica.</p>
              </Fragment>
          }
        ]
      }

    }

  },
  navBar:false
}

const themeConfigGamblingGA = {
  app: {
    appName: process.env.REACT_APP_MARCA_BLANCA,
    appLogoImage: require('@src/assets/images/logo/logo.svg').default,
    type: 'Gambling'
  },
  layout: {
    isRTL: false,
    skin: 'light', // light, dark, bordered, semi-dark
    routerTransition: 'pulse', // fadeIn, fadeInLeft, zoomIn, none or check this for more transition https://animate.style/
    type: 'vertical', // vertical, horizontal
    contentWidth: 'full', // full, boxed
    menu: {
      isHidden: true,
      isCollapsed: false
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: 'hidden', // static , sticky , floating, hidden
      backgroundColor: 'white' // BS color options [primary, success, etc]
    },
    footer: {
      type: 'static' // static, sticky, hidden
    },
    customizer: false,
    scrollTop: true // Enable scroll to top button
  },
  header: {
    headerText: 'Ecco il tuo comparatore bonus definitivo e aggiornato.',
    headerText2: 'Confrontiamo i bonus di benvenuto dei vari operatori di gioco online con regolare licenza aams.',
    headerText3: 'Oltre ai bonus è possibile trovare altre informazioni per conoscere meglio la sala e scegliere cosi tra una vasta offerta di possibilitá.'
  },
  footer: {
    rigthText: 'Il gioco può causare dipendenza patologica | Gioca Responsabilmente | © Ltd 2021 | info@gamingaffiliation',
    footerBanner: false,
    Faqs: {
      initial: {
        title: 'Privacy & Cookies',
        link: '/faq/Privacy'
      },
      middle: {
        title: 'Gioco Responsabile',
        link: '/faq/Responsabile'
      },
      last: {
        title: 'Disclaimer',
        link: '/faq/Disclaimer'
      }
    },
    faqData: {
      // payment
      privacy: {
        icon: 'AlertCircle',
        title: 'Privacy',
        subtitle: 'Privacy & Cookies',
        qandA: [
          {
            question: 'Privacy Policy',
            ans: " Da " + process.env.REACT_APP_MARCA_BLANCA_DOMAIN + " puntiamo sul valore della privacy, sicurezza e affidabilità non soltanto nelle nostre recensioni dei concessionari di gioco ma anche all'interno del sito che mettiamo a disposizione dei visitatori. Abbiamo creato questa pagina con l'informativa sulla privacy per rendervi consapevoli di come i dati da voi forniti vengano trattati, di come " + process.env.REACT_APP_MARCA_BLANCA_DOMAIN + " garantisca la tutela della privacy dell'utente e sul funzionamento generale del nostro sito. Con l'uso del nostro prodotto, concordi alle seguenti disposizioni e condizioni d'uso"
          },
          {
            question: '  Finalità del trattamento',
            ans: 'Il sito web e il servizio ' + process.env.REACT_APP_MARCA_BLANCA_DOMAIN + '  possono essere utilizzati senza registrazione, pertanto gli unici dati raccolti sono quelli di Google Analytics. I dati raccolti vengono utilizzati per migliorare il prodotto disponibile su ' + process.env.REACT_APP_MARCA_BLANCA_DOMAIN + '.'
          },
          {
            question: 'Definizioni',
            ans:
              <ul>
                <li>{'Prodotto: Il prodotto è il sito web ' + process.env.REACT_APP_MARCA_BLANCA_DOMAIN}</li>
                <li>Dati personali: i dati personali comprendono l'indirizzo e-mail fornito volontariamente.</li>
                <li>Dati dell'utente: i dati dell'utente sono quelli raccolti automaticamente con l'uso del nostro prodotto, come il tempo trascorso sul sito o il numero di pagine visitate.</li>
              </ul>
          },
          {
            question: 'Metodo di lavorazione',
            ans: ' I dati raccolti vengono trattati con la massima riservatezza, utilizzando misure di sicurezza informatica che ne impediscono la visione da parte di fonti esterne. Si precisa inoltre che i dati forniti non saranno diffusi o comunicati a società esterne.'
          },
          {
            question: 'Utilizzo dei cookie',
            ans: "Utilizziamo i cookie al solo scopo di analizzare i dati degli utenti raccolti tramite Google Analytics. Questi dati dell'utente ci permettono di migliorare il nostro servizio per la vostra prossima visita."
          },
          {
            question: 'Titolare del trattamento dei dati',
            ans: process.env.REACT_APP_MARCA_BLANCA_DOMAIN
          }
        ]
      },
      // delivery
      responsability: {
        icon: 'UserCheck',
        title: 'Responsabile',
        subtitle: 'Gioco Responsabile',
        qandA: [
          {
            question: 'Cosa sono le scommesse?',
            ans: " Scommettere online è un passatempo sempre più diffuso, anche grazie agli smartphone  che semplificano l’accesso ai bookmaker. Il Gioco però comporta dei rischi di perdite di denaro, per cui è molto importante che gli utenti che amano scommettere lo facciano in maniera consapevole e responsabile, senza esagerare."
          },
          {
            question: "Come sosteniamo il gioco d'azzardo responsabile?",
            ans: process.env.REACT_APP_MARCA_BLANCA_DOMAIN + "il gioco responsabile, invitando i nostri utenti a giocare con moderazione solo ed esclusivamente su siti scommesse ADM, gli unici in grado di garantire un elevato livello di protezione del giocatore. Alle volte l’abuso può trasformarsi in una dipendenza da gioco d’azzardo, con gravi ripercussioni su salute, affetti e vita professionale, e per questo è importante intervenire tempestivamente. "
          },
          {
            question: "Quando bisogna preoccuparsi?",
            ans: "La ludopatia è un desiderio incontrollabile di giocare e scommettere, senza pensare ad alcune ripercussioni negative sulla salute della persona. Non solo: essa può portare anche problemi dal punto di vista delle finanze, dei rapporti lavorativi e interpersonali."
          },
          {
            question: "Quali comportamenti può avere una persona affetta da disturbo da gioco d'azzardo patologico?",
            ans:
              <Fragment>
                <span>Secondo le indicazioni dell’Organizzazione Mondiale della Sanità. Ecco i sintomi tipici di una dipendenza come la ludopatia:</span>
                <ul>
                  <li>Pensare al gioco d’azzardo in modo ossessivo.</li>
                  <li>Ricerca dell’”adrenalina della vittoria” alzando sempre l’asticella.</li>
                  <li>Desiderio del gioco impossibile da reprimere.</li>
                  <li>Quando non si gioca ci si sente stressati o irrequieti.</li>
                  <li>Vedere le scommesse o il gioco come una soluzione dei problemi.</li>
                  <li>Giocare al di sopra delle proprie possibilità finanziarie per recuperare il denaro perso.</li>
                  <li>Procurarsi il denaro necessario rubando o commettendo altri atti illeciti.</li>
                  <li>Rischiare il proprio lavoro o gli affetti per il gioco o le scommesse.</li>
                  <li>Chiedere prestiti di denaro a conoscenti o amici per giocare.</li>
                  <li>Non essere sinceri con familiari e amici riguardo il problema.</li>
                  <li>Impostare dei Limiti di Gioco.</li>
                </ul>
              </Fragment>
          },
          {
            question: 'Che soluzione posso adottare?',
            ans: "Una soluzione per controllare i propri comportamenti ed evitare che essi possano degenerare è di certo quello di imporsi dei limiti di spesa. Questo tipo di precauzione può essere presa dall’utente già in fase di registrazione ad una piattaforma di gioco online, in quanto nel form di registrazione c’è sempre questa opzione sui limiti di gioco. A cosa serve? Questo metodo può dare all’utente un limite di budget settimanale o mensile di ricarica sul proprio conto online. Per fare un esempio: se si imposta un limite di ricarica di 1000€ al mese, sarà lo stesso bookmaker ADM (ex AAMS) ad impedire al giocatore versamenti che vadano oltre quel limite mensile sull’account di gioco personale. Questi limiti di gioco da impostare in fase di registrazione, inoltre, possono essere modificati anche successivamente all’iscrizione grazie a delle opzioni presenti sul proprio account online."
          },
          {
            question: "Prendersi un periodo di pausa: l’auto-esclusione",
            ans: "Altra soluzione che può utilizzare un utente che crede di aver bisogno di limitare il proprio gioco d’azzardo è quella dell’auto-esclusione. Questo strumento è presente in tutti i bookmakers online ed è grazie ad esso che l’utente può mettere in pausa il proprio conto gioco online. Questo tipo di funzione dell’auto-esclusione, inoltre, se viene attivata ha effetto su tutte le piattaforme di scommesse ADM: per quell’utente, dunque, sarà impossibile anche aprire un nuovo gioco su un altro sito di scommesse ADM. Questo strumento di auto-esclusione può essere attivato in due modalità: tempo determinato, per un numero di giorni che l’utente stabilirà fino ad un massimo di 90, oppure a tempo indeterminato, minimo 6 mesi. In questo periodo di pausa, dunque, l’utente: può accedere al proprio conto gioco online e ritirare l’eventuale denaro presente non può ricaricare il proprio account con versamente né scommettere Una volta attivato il metodo di auto-esclusione a tempo determinato, esso si conclude automaticamente una volta passato il tempo scelto dall’utente. Se si imposta una esclusione a tempo indeterminato, invece, solo dopo almeno 6 mesi si può riattivare il proprio conto gioco con tutte le sue funzioni, dopo aver inviato una comunicazione alla piattaforma online. Se si è scelta questa modalità di auto-esclusione a tempo indeterminato, bisognerà fare molta attenzione ad essere ben pronti quando si ritorna ad attivare il proprio conto gioco."
          },
          {
            question: 'Che soluzione posso adottare?',
            ans: "Una soluzione per controllare i propri comportamenti ed evitare che essi possano degenerare è di certo quello di imporsi dei limiti di spesa. Questo tipo di precauzione può essere presa dall’utente già in fase di registrazione ad una piattaforma di gioco online, in quanto nel form di registrazione c’è sempre questa opzione sui limiti di gioco. A cosa serve? Questo metodo può dare all’utente un limite di budget settimanale o mensile di ricarica sul proprio conto online. Per fare un esempio: se si imposta un limite di ricarica di 1000€ al mese, sarà lo stesso bookmaker ADM (ex AAMS) ad impedire al giocatore versamenti che vadano oltre quel limite mensile sull’account di gioco personale. Questi limiti di gioco da impostare in fase di registrazione, inoltre, possono essere modificati anche successivamente all’iscrizione grazie a delle opzioni presenti sul proprio account online."
          },
        ]
      },
      // cancellation and return
      disclaimer: {
        icon: 'Tag',
        title: 'Disclaimer',
        subtitle: 'Disclaimer',
        qandA: [
          {
            question: ' Il sito ' + process.env.REACT_APP_MARCA_BLANCA_DOMAIN + ' non è una testata giornalistica',
            ans:
              <Fragment>
                <p> {'Il sito ' + process.env.REACT_APP_MARCA_BLANCA_DOMAIN + ' non è una testata giornalistica in quanto viene aggiornato senza alcuna regolarità. Non può quindi considerarsi un prodotto editoriale ai sensi della legge n° 62 del 7.03.2001.'}
                </p>
                <p>   Lo scopo del sito è quello di fornire informazioni sulle migliori slot online. Inoltre, verifichiamo la sicurezza e l’affidabilità dei Bookmaker Online ADM. Il tutto attraverso un’analisi comparativa delle offerte bonus degli operatori.</p>
                <p>Puoi giocare d’azzardo solo se hai compiuto 18 anni.
                  Il gioco può causare dipendenza patologica.</p>
              </Fragment>
          }
        ]
      }

    }

  },
  navBar:true
}
const themeConfigGamblingBonusWelcome = {
  app: {
    appName: process.env.REACT_APP_MARCA_BLANCA,
    appLogoImage: require('@src/assets/images/logo/logo.svg').default,
    type: 'Gambling'
  },
  layout: {
    isRTL: false,
    skin: 'dark', // light, dark, bordered, semi-dark
    routerTransition: 'pulse', // fadeIn, fadeInLeft, zoomIn, none or check this for more transition https://animate.style/
    type: 'vertical', // vertical, horizontal
    contentWidth: 'full', // full, boxed
    menu: {
      isHidden: true,
      isCollapsed: false
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: 'hidden', // static , sticky , floating, hidden
      backgroundColor: 'white' // BS color options [primary, success, etc]
    },
    footer: {
      type: 'static' // static, sticky, hidden
    },
    customizer: false,
    scrollTop: true // Enable scroll to top button
  },
  header: {
    headerText: 'Ecco il tuo comparatore bonus definitivo e aggiornato.',
    headerText2: 'Confrontiamo i bonus di benvenuto dei vari operatori di gioco online con regolare licenza aams.',
    headerText3: 'Oltre ai bonus è possibile trovare altre informazioni per conoscere meglio la sala e scegliere cosi tra una vasta offerta di possibilitá.'
  },
  footer: {
    rigthText: 'Il gioco può causare dipendenza patologica | Gioca Responsabilmente | © Ltd 2021',
    footerBanner: true,
    footerBannerImage: require('@src/assets/gamingbanner.png').default,
    Faqs: {
      initial: {
        title: 'Privacy & Cookies',
        link: '/faq/Privacy'
      },
      middle: {
        title: 'Gioco Responsabile',
        link: '/faq/Responsabile'
      },
      last: {
        title: 'Disclaimer',
        link: '/faq/Disclaimer'
      }
    },
    faqData: {
      // payment
      privacy: {
        icon: 'AlertCircle',
        title: 'Privacy',
        subtitle: 'Privacy & Cookies',
        qandA: [
          {
            question: 'Privacy Policy',
            ans: " Da " + process.env.REACT_APP_MARCA_BLANCA_DOMAIN + " puntiamo sul valore della privacy, sicurezza e affidabilità non soltanto nelle nostre recensioni dei concessionari di gioco ma anche all'interno del sito che mettiamo a disposizione dei visitatori. Abbiamo creato questa pagina con l'informativa sulla privacy per rendervi consapevoli di come i dati da voi forniti vengano trattati, di come " + process.env.REACT_APP_MARCA_BLANCA_DOMAIN + " garantisca la tutela della privacy dell'utente e sul funzionamento generale del nostro sito. Con l'uso del nostro prodotto, concordi alle seguenti disposizioni e condizioni d'uso"
          },
          {
            question: '  Finalità del trattamento',
            ans: 'Il sito web e il servizio ' + process.env.REACT_APP_MARCA_BLANCA_DOMAIN + '  possono essere utilizzati senza registrazione, pertanto gli unici dati raccolti sono quelli di Google Analytics. I dati raccolti vengono utilizzati per migliorare il prodotto disponibile su ' + process.env.REACT_APP_MARCA_BLANCA_DOMAIN + '.'
          },
          {
            question: 'Definizioni',
            ans:
              <ul>
                <li>{'Prodotto: Il prodotto è il sito web ' + process.env.REACT_APP_MARCA_BLANCA_DOMAIN}</li>
                <li>Dati personali: i dati personali comprendono l'indirizzo e-mail fornito volontariamente.</li>
                <li>Dati dell'utente: i dati dell'utente sono quelli raccolti automaticamente con l'uso del nostro prodotto, come il tempo trascorso sul sito o il numero di pagine visitate.</li>
              </ul>
          },
          {
            question: 'Metodo di lavorazione',
            ans: ' I dati raccolti vengono trattati con la massima riservatezza, utilizzando misure di sicurezza informatica che ne impediscono la visione da parte di fonti esterne. Si precisa inoltre che i dati forniti non saranno diffusi o comunicati a società esterne.'
          },
          {
            question: 'Utilizzo dei cookie',
            ans: "Utilizziamo i cookie al solo scopo di analizzare i dati degli utenti raccolti tramite Google Analytics. Questi dati dell'utente ci permettono di migliorare il nostro servizio per la vostra prossima visita."
          },
          {
            question: 'Titolare del trattamento dei dati',
            ans: process.env.REACT_APP_MARCA_BLANCA_DOMAIN
          }
        ]
      },
      // delivery
      responsability: {
        icon: 'UserCheck',
        title: 'Responsabile',
        subtitle: 'Gioco Responsabile',
        qandA: [
          {
            question: 'Cosa sono le scommesse?',
            ans: " Scommettere online è un passatempo sempre più diffuso, anche grazie agli smartphone  che semplificano l’accesso ai bookmaker. Il Gioco però comporta dei rischi di perdite di denaro, per cui è molto importante che gli utenti che amano scommettere lo facciano in maniera consapevole e responsabile, senza esagerare."
          },
          {
            question: "Come sosteniamo il gioco d'azzardo responsabile?",
            ans: process.env.REACT_APP_MARCA_BLANCA_DOMAIN + "il gioco responsabile, invitando i nostri utenti a giocare con moderazione solo ed esclusivamente su siti scommesse ADM, gli unici in grado di garantire un elevato livello di protezione del giocatore. Alle volte l’abuso può trasformarsi in una dipendenza da gioco d’azzardo, con gravi ripercussioni su salute, affetti e vita professionale, e per questo è importante intervenire tempestivamente. "
          },
          {
            question: "Quando bisogna preoccuparsi?",
            ans: "La ludopatia è un desiderio incontrollabile di giocare e scommettere, senza pensare ad alcune ripercussioni negative sulla salute della persona. Non solo: essa può portare anche problemi dal punto di vista delle finanze, dei rapporti lavorativi e interpersonali."
          },
          {
            question: "Quali comportamenti può avere una persona affetta da disturbo da gioco d'azzardo patologico?",
            ans:
              <Fragment>
                <span>Secondo le indicazioni dell’Organizzazione Mondiale della Sanità. Ecco i sintomi tipici di una dipendenza come la ludopatia:</span>
                <ul>
                  <li>Pensare al gioco d’azzardo in modo ossessivo.</li>
                  <li>Ricerca dell’”adrenalina della vittoria” alzando sempre l’asticella.</li>
                  <li>Desiderio del gioco impossibile da reprimere.</li>
                  <li>Quando non si gioca ci si sente stressati o irrequieti.</li>
                  <li>Vedere le scommesse o il gioco come una soluzione dei problemi.</li>
                  <li>Giocare al di sopra delle proprie possibilità finanziarie per recuperare il denaro perso.</li>
                  <li>Procurarsi il denaro necessario rubando o commettendo altri atti illeciti.</li>
                  <li>Rischiare il proprio lavoro o gli affetti per il gioco o le scommesse.</li>
                  <li>Chiedere prestiti di denaro a conoscenti o amici per giocare.</li>
                  <li>Non essere sinceri con familiari e amici riguardo il problema.</li>
                  <li>Impostare dei Limiti di Gioco.</li>
                </ul>
              </Fragment>
          },
          {
            question: 'Che soluzione posso adottare?',
            ans: "Una soluzione per controllare i propri comportamenti ed evitare che essi possano degenerare è di certo quello di imporsi dei limiti di spesa. Questo tipo di precauzione può essere presa dall’utente già in fase di registrazione ad una piattaforma di gioco online, in quanto nel form di registrazione c’è sempre questa opzione sui limiti di gioco. A cosa serve? Questo metodo può dare all’utente un limite di budget settimanale o mensile di ricarica sul proprio conto online. Per fare un esempio: se si imposta un limite di ricarica di 1000€ al mese, sarà lo stesso bookmaker ADM (ex AAMS) ad impedire al giocatore versamenti che vadano oltre quel limite mensile sull’account di gioco personale. Questi limiti di gioco da impostare in fase di registrazione, inoltre, possono essere modificati anche successivamente all’iscrizione grazie a delle opzioni presenti sul proprio account online."
          },
          {
            question: "Prendersi un periodo di pausa: l’auto-esclusione",
            ans: "Altra soluzione che può utilizzare un utente che crede di aver bisogno di limitare il proprio gioco d’azzardo è quella dell’auto-esclusione. Questo strumento è presente in tutti i bookmakers online ed è grazie ad esso che l’utente può mettere in pausa il proprio conto gioco online. Questo tipo di funzione dell’auto-esclusione, inoltre, se viene attivata ha effetto su tutte le piattaforme di scommesse ADM: per quell’utente, dunque, sarà impossibile anche aprire un nuovo gioco su un altro sito di scommesse ADM. Questo strumento di auto-esclusione può essere attivato in due modalità: tempo determinato, per un numero di giorni che l’utente stabilirà fino ad un massimo di 90, oppure a tempo indeterminato, minimo 6 mesi. In questo periodo di pausa, dunque, l’utente: può accedere al proprio conto gioco online e ritirare l’eventuale denaro presente non può ricaricare il proprio account con versamente né scommettere Una volta attivato il metodo di auto-esclusione a tempo determinato, esso si conclude automaticamente una volta passato il tempo scelto dall’utente. Se si imposta una esclusione a tempo indeterminato, invece, solo dopo almeno 6 mesi si può riattivare il proprio conto gioco con tutte le sue funzioni, dopo aver inviato una comunicazione alla piattaforma online. Se si è scelta questa modalità di auto-esclusione a tempo indeterminato, bisognerà fare molta attenzione ad essere ben pronti quando si ritorna ad attivare il proprio conto gioco."
          },
          {
            question: 'Che soluzione posso adottare?',
            ans: "Una soluzione per controllare i propri comportamenti ed evitare che essi possano degenerare è di certo quello di imporsi dei limiti di spesa. Questo tipo di precauzione può essere presa dall’utente già in fase di registrazione ad una piattaforma di gioco online, in quanto nel form di registrazione c’è sempre questa opzione sui limiti di gioco. A cosa serve? Questo metodo può dare all’utente un limite di budget settimanale o mensile di ricarica sul proprio conto online. Per fare un esempio: se si imposta un limite di ricarica di 1000€ al mese, sarà lo stesso bookmaker ADM (ex AAMS) ad impedire al giocatore versamenti che vadano oltre quel limite mensile sull’account di gioco personale. Questi limiti di gioco da impostare in fase di registrazione, inoltre, possono essere modificati anche successivamente all’iscrizione grazie a delle opzioni presenti sul proprio account online."
          },
        ]
      },
      // cancellation and return
      disclaimer: {
        icon: 'Tag',
        title: 'Disclaimer',
        subtitle: 'Disclaimer',
        qandA: [
          {
            question: ' Il sito ' + process.env.REACT_APP_MARCA_BLANCA_DOMAIN + ' non è una testata giornalistica',
            ans:
              <Fragment>
                <p> {'Il sito ' + process.env.REACT_APP_MARCA_BLANCA_DOMAIN + ' non è una testata giornalistica in quanto viene aggiornato senza alcuna regolarità. Non può quindi considerarsi un prodotto editoriale ai sensi della legge n° 62 del 7.03.2001.'}
                </p>
                <p>   Lo scopo del sito è quello di fornire informazioni sulle migliori slot online. Inoltre, verifichiamo la sicurezza e l’affidabilità dei Bookmaker Online ADM. Il tutto attraverso un’analisi comparativa delle offerte bonus degli operatori.</p>
                <p>Puoi giocare d’azzardo solo se hai compiuto 18 anni.
                  Il gioco può causare dipendenza patologica.</p>
              </Fragment>
          }
        ]
      }

    }
    
  },
  navBar:false
}
const themeConfigGamblingPlaynowGames = {
  app: {
    appName: process.env.REACT_APP_MARCA_BLANCA,
    appLogoImage: require('@src/assets/images/logo/logo.svg').default,
    type: 'Gambling'
  },
  layout: {
    isRTL: false,
    skin: 'dark', // light, dark, bordered, semi-dark
    routerTransition: 'pulse', // fadeIn, fadeInLeft, zoomIn, none or check this for more transition https://animate.style/
    type: 'vertical', // vertical, horizontal
    contentWidth: 'full', // full, boxed
    menu: {
      isHidden: true,
      isCollapsed: false
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: 'hidden', // static , sticky , floating, hidden
      backgroundColor: 'white' // BS color options [primary, success, etc]
    },
    footer: {
      type: 'static' // static, sticky, hidden
    },
    customizer: false,
    scrollTop: true // Enable scroll to top button
  },
  header: {
    headerText: 'Ecco il tuo comparatore bonus definitivo e aggiornato.',
    headerText2: 'Confrontiamo i bonus di benvenuto dei vari operatori di gioco online con regolare licenza aams.',
    headerText3: 'Oltre ai bonus è possibile trovare altre informazioni per conoscere meglio la sala e scegliere cosi tra una vasta offerta di possibilitá.'
  },
  footer: {
    rigthText: 'Il gioco può causare dipendenza patologica | Gioca Responsabilmente | © Ltd 2021',
    footerBanner: true,
    footerBannerImage: require('@src/assets/gamingbanner.png').default,
    Faqs: {
      initial: {
        title: 'Privacy & Cookies',
        link: '/faq/Privacy'
      },
      middle: {
        title: 'Gioco Responsabile',
        link: '/faq/Responsabile'
      },
      last: {
        title: 'Disclaimer',
        link: '/faq/Disclaimer'
      }
    },
    faqData: {
      // payment
      privacy: {
        icon: 'AlertCircle',
        title: 'Privacy',
        subtitle: 'Privacy & Cookies',
        qandA: [
          {
            question: 'Privacy Policy',
            ans: " Da " + process.env.REACT_APP_MARCA_BLANCA_DOMAIN + " puntiamo sul valore della privacy, sicurezza e affidabilità non soltanto nelle nostre recensioni dei concessionari di gioco ma anche all'interno del sito che mettiamo a disposizione dei visitatori. Abbiamo creato questa pagina con l'informativa sulla privacy per rendervi consapevoli di come i dati da voi forniti vengano trattati, di come " + process.env.REACT_APP_MARCA_BLANCA_DOMAIN + " garantisca la tutela della privacy dell'utente e sul funzionamento generale del nostro sito. Con l'uso del nostro prodotto, concordi alle seguenti disposizioni e condizioni d'uso"
          },
          {
            question: '  Finalità del trattamento',
            ans: 'Il sito web e il servizio ' + process.env.REACT_APP_MARCA_BLANCA_DOMAIN + '  possono essere utilizzati senza registrazione, pertanto gli unici dati raccolti sono quelli di Google Analytics. I dati raccolti vengono utilizzati per migliorare il prodotto disponibile su ' + process.env.REACT_APP_MARCA_BLANCA_DOMAIN + '.'
          },
          {
            question: 'Definizioni',
            ans:
              <ul>
                <li>{'Prodotto: Il prodotto è il sito web ' + process.env.REACT_APP_MARCA_BLANCA_DOMAIN}</li>
                <li>Dati personali: i dati personali comprendono l'indirizzo e-mail fornito volontariamente.</li>
                <li>Dati dell'utente: i dati dell'utente sono quelli raccolti automaticamente con l'uso del nostro prodotto, come il tempo trascorso sul sito o il numero di pagine visitate.</li>
              </ul>
          },
          {
            question: 'Metodo di lavorazione',
            ans: ' I dati raccolti vengono trattati con la massima riservatezza, utilizzando misure di sicurezza informatica che ne impediscono la visione da parte di fonti esterne. Si precisa inoltre che i dati forniti non saranno diffusi o comunicati a società esterne.'
          },
          {
            question: 'Utilizzo dei cookie',
            ans: "Utilizziamo i cookie al solo scopo di analizzare i dati degli utenti raccolti tramite Google Analytics. Questi dati dell'utente ci permettono di migliorare il nostro servizio per la vostra prossima visita."
          },
          {
            question: 'Titolare del trattamento dei dati',
            ans: process.env.REACT_APP_MARCA_BLANCA_DOMAIN
          }
        ]
      },
      // delivery
      responsability: {
        icon: 'UserCheck',
        title: 'Responsabile',
        subtitle: 'Gioco Responsabile',
        qandA: [
          {
            question: 'Cosa sono le scommesse?',
            ans: " Scommettere online è un passatempo sempre più diffuso, anche grazie agli smartphone  che semplificano l’accesso ai bookmaker. Il Gioco però comporta dei rischi di perdite di denaro, per cui è molto importante che gli utenti che amano scommettere lo facciano in maniera consapevole e responsabile, senza esagerare."
          },
          {
            question: "Come sosteniamo il gioco d'azzardo responsabile?",
            ans: process.env.REACT_APP_MARCA_BLANCA_DOMAIN + "il gioco responsabile, invitando i nostri utenti a giocare con moderazione solo ed esclusivamente su siti scommesse ADM, gli unici in grado di garantire un elevato livello di protezione del giocatore. Alle volte l’abuso può trasformarsi in una dipendenza da gioco d’azzardo, con gravi ripercussioni su salute, affetti e vita professionale, e per questo è importante intervenire tempestivamente. "
          },
          {
            question: "Quando bisogna preoccuparsi?",
            ans: "La ludopatia è un desiderio incontrollabile di giocare e scommettere, senza pensare ad alcune ripercussioni negative sulla salute della persona. Non solo: essa può portare anche problemi dal punto di vista delle finanze, dei rapporti lavorativi e interpersonali."
          },
          {
            question: "Quali comportamenti può avere una persona affetta da disturbo da gioco d'azzardo patologico?",
            ans:
              <Fragment>
                <span>Secondo le indicazioni dell’Organizzazione Mondiale della Sanità. Ecco i sintomi tipici di una dipendenza come la ludopatia:</span>
                <ul>
                  <li>Pensare al gioco d’azzardo in modo ossessivo.</li>
                  <li>Ricerca dell’”adrenalina della vittoria” alzando sempre l’asticella.</li>
                  <li>Desiderio del gioco impossibile da reprimere.</li>
                  <li>Quando non si gioca ci si sente stressati o irrequieti.</li>
                  <li>Vedere le scommesse o il gioco come una soluzione dei problemi.</li>
                  <li>Giocare al di sopra delle proprie possibilità finanziarie per recuperare il denaro perso.</li>
                  <li>Procurarsi il denaro necessario rubando o commettendo altri atti illeciti.</li>
                  <li>Rischiare il proprio lavoro o gli affetti per il gioco o le scommesse.</li>
                  <li>Chiedere prestiti di denaro a conoscenti o amici per giocare.</li>
                  <li>Non essere sinceri con familiari e amici riguardo il problema.</li>
                  <li>Impostare dei Limiti di Gioco.</li>
                </ul>
              </Fragment>
          },
          {
            question: 'Che soluzione posso adottare?',
            ans: "Una soluzione per controllare i propri comportamenti ed evitare che essi possano degenerare è di certo quello di imporsi dei limiti di spesa. Questo tipo di precauzione può essere presa dall’utente già in fase di registrazione ad una piattaforma di gioco online, in quanto nel form di registrazione c’è sempre questa opzione sui limiti di gioco. A cosa serve? Questo metodo può dare all’utente un limite di budget settimanale o mensile di ricarica sul proprio conto online. Per fare un esempio: se si imposta un limite di ricarica di 1000€ al mese, sarà lo stesso bookmaker ADM (ex AAMS) ad impedire al giocatore versamenti che vadano oltre quel limite mensile sull’account di gioco personale. Questi limiti di gioco da impostare in fase di registrazione, inoltre, possono essere modificati anche successivamente all’iscrizione grazie a delle opzioni presenti sul proprio account online."
          },
          {
            question: "Prendersi un periodo di pausa: l’auto-esclusione",
            ans: "Altra soluzione che può utilizzare un utente che crede di aver bisogno di limitare il proprio gioco d’azzardo è quella dell’auto-esclusione. Questo strumento è presente in tutti i bookmakers online ed è grazie ad esso che l’utente può mettere in pausa il proprio conto gioco online. Questo tipo di funzione dell’auto-esclusione, inoltre, se viene attivata ha effetto su tutte le piattaforme di scommesse ADM: per quell’utente, dunque, sarà impossibile anche aprire un nuovo gioco su un altro sito di scommesse ADM. Questo strumento di auto-esclusione può essere attivato in due modalità: tempo determinato, per un numero di giorni che l’utente stabilirà fino ad un massimo di 90, oppure a tempo indeterminato, minimo 6 mesi. In questo periodo di pausa, dunque, l’utente: può accedere al proprio conto gioco online e ritirare l’eventuale denaro presente non può ricaricare il proprio account con versamente né scommettere Una volta attivato il metodo di auto-esclusione a tempo determinato, esso si conclude automaticamente una volta passato il tempo scelto dall’utente. Se si imposta una esclusione a tempo indeterminato, invece, solo dopo almeno 6 mesi si può riattivare il proprio conto gioco con tutte le sue funzioni, dopo aver inviato una comunicazione alla piattaforma online. Se si è scelta questa modalità di auto-esclusione a tempo indeterminato, bisognerà fare molta attenzione ad essere ben pronti quando si ritorna ad attivare il proprio conto gioco."
          },
          {
            question: 'Che soluzione posso adottare?',
            ans: "Una soluzione per controllare i propri comportamenti ed evitare che essi possano degenerare è di certo quello di imporsi dei limiti di spesa. Questo tipo di precauzione può essere presa dall’utente già in fase di registrazione ad una piattaforma di gioco online, in quanto nel form di registrazione c’è sempre questa opzione sui limiti di gioco. A cosa serve? Questo metodo può dare all’utente un limite di budget settimanale o mensile di ricarica sul proprio conto online. Per fare un esempio: se si imposta un limite di ricarica di 1000€ al mese, sarà lo stesso bookmaker ADM (ex AAMS) ad impedire al giocatore versamenti che vadano oltre quel limite mensile sull’account di gioco personale. Questi limiti di gioco da impostare in fase di registrazione, inoltre, possono essere modificati anche successivamente all’iscrizione grazie a delle opzioni presenti sul proprio account online."
          },
        ]
      },
      // cancellation and return
      disclaimer: {
        icon: 'Tag',
        title: 'Disclaimer',
        subtitle: 'Disclaimer',
        qandA: [
          {
            question: ' Il sito ' + process.env.REACT_APP_MARCA_BLANCA_DOMAIN + ' non è una testata giornalistica',
            ans:
              <Fragment>
                <p> {'Il sito ' + process.env.REACT_APP_MARCA_BLANCA_DOMAIN + ' non è una testata giornalistica in quanto viene aggiornato senza alcuna regolarità. Non può quindi considerarsi un prodotto editoriale ai sensi della legge n° 62 del 7.03.2001.'}
                </p>
                <p>   Lo scopo del sito è quello di fornire informazioni sulle migliori slot online. Inoltre, verifichiamo la sicurezza e l’affidabilità dei Bookmaker Online ADM. Il tutto attraverso un’analisi comparativa delle offerte bonus degli operatori.</p>
                <p>Puoi giocare d’azzardo solo se hai compiuto 18 anni.
                  Il gioco può causare dipendenza patologica.</p>
              </Fragment>
          }
        ]
      }

    }
    
  },
  navBar:false
}
const themeConfigGamblingBrasiliaconnect = {
  app: {
    appName: process.env.REACT_APP_MARCA_BLANCA,
    appLogoImage: require('@src/assets/images/logo/logo.svg').default,
    type: 'Gambling'
  },
  layout: {
    isRTL: false,
    skin: 'dark', // light, dark, bordered, semi-dark
    routerTransition: 'pulse', // fadeIn, fadeInLeft, zoomIn, none or check this for more transition https://animate.style/
    type: 'vertical', // vertical, horizontal
    contentWidth: 'full', // full, boxed
    menu: {
      isHidden: true,
      isCollapsed: false
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: 'hidden', // static , sticky , floating, hidden
      backgroundColor: 'white' // BS color options [primary, success, etc]
    },
    footer: {
      type: 'static' // static, sticky, hidden
    },
    customizer: false,
    scrollTop: true // Enable scroll to top button
  },

  header: {
    headerText: 'Here is your ultimate and up-to-date bonus comparator.',
    headerText2: 'We compare welcome bonuses from different online gaming operators licensed by AAMS.',
    headerText3: 'In addition to bonuses, you can find other information to better understand the platform and choose from a wide range of options.'
  },
  footer: {
    rigthText: 'Gambling can be addictive | Play responsibly | © Ltd 2021',
    footerBanner: true,
    footerlink: 'https://ibjr.org/',
    footerBannerImage: require('@src/assets/brasiliafooter.png').default,
    Faqs: {
      initial: {
        title: 'Privacy and Cookies',
        link: '/faq/Privacy'
      },
      middle: {
        title: 'Responsible Gaming',
        link: '/faq/Responsible'
      },
      last: {
        title: 'Legal Notice',
        link: '/faq/LegalNotice'
      }
    },
    faqData: {
      // Privacy
      privacy: {
        icon: 'AlertCircle',
        title: 'Privacy',
        subtitle: 'Privacy and Cookies',
        qandA: [
          {
            question: 'Privacy Policy',
            ans: "At " + process.env.REACT_APP_MARCA_BLANCA_DOMAIN + ", we value your privacy and security. We not only review gaming operators, but also ensure the protection of your data on our site. In this section, we explain how we handle your information and ensure the confidentiality of your data. By using our service, you accept our policies and terms."
          },
          {
            question: 'Purpose of Data Processing',
            ans: "You can use " + process.env.REACT_APP_MARCA_BLANCA_DOMAIN + " without registering. We only collect data through Google Analytics to improve the user experience on our platform."
          },
          {
            question: 'Definitions',
            ans:
              <ul>
                <li>{'Product: The web platform ' + process.env.REACT_APP_MARCA_BLANCA_DOMAIN}</li>
                <li>Personal data: Information such as email voluntarily provided.</li>
                <li>User data: Data automatically collected, such as browsing time or visited pages.</li>
              </ul>
          },
          {
            question: 'Security and Confidentiality',
            ans: "Data is processed with full confidentiality and protected with advanced security measures. We do not share information with third parties."
          },
          {
            question: 'Use of Cookies',
            ans: "We use cookies only to analyze activity on our website and improve your experience."
          },
          {
            question: 'Data Controller',
            ans: process.env.REACT_APP_MARCA_BLANCA_DOMAIN
          }
        ]
      },
      // Responsible Gaming
      responsability: {
        icon: 'UserCheck',
        title: 'Responsible Gaming',
        subtitle: 'Play with Control',
        qandA: [
          {
            question: 'What is gambling?',
            ans: "Online gambling is a popular form of entertainment, especially due to the accessibility of mobile devices. However, it is essential to play responsibly and not bet more than you can afford to lose."
          },
          {
            question: "How do we promote responsible gaming?",
            ans: "At " + process.env.REACT_APP_MARCA_BLANCA_DOMAIN + ", we promote safe and responsible gaming. We recommend betting only on sites with an official license, avoiding financial and emotional risks."
          },
          {
            question: "When should you be concerned?",
            ans: "Gambling addiction is an uncontrollable urge to bet, which can lead to financial and personal problems. If you feel anxious when not playing or bet more than you can afford, it's time to seek help."
          },
          {
            question: "How to know if someone has gambling problems?",
            ans:
              <ul>
                <li>Obsession with gambling.</li>
                <li>Betting increasing amounts of money.</li>
                <li>Anxiety or irritability when not playing.</li>
                <li>Seeing gambling as a financial solution.</li>
                <li>Borrowing money to gamble.</li>
                <li>Lying about the amount of money bet.</li>
                <li>Neglecting personal relationships or work due to gambling.</li>
              </ul>
          },
          {
            question: 'What solutions exist?',
            ans: "Setting weekly or monthly deposit limits on gaming platforms can help you control your budget and prevent excessive gambling."
          },
          {
            question: "Pauses and self-exclusion",
            ans: "If you believe you need a break from gambling, most operators allow you to self-exclude temporarily or indefinitely, preventing access to gambling during that period."
          }
        ]
      },
      // Legal Notice
      disclaimer: {
        icon: 'Tag',
        title: 'Legal Notice',
        subtitle: 'Legal Information',
        qandA: [
          {
            question: "Is " + process.env.REACT_APP_MARCA_BLANCA_DOMAIN + " a media outlet?",
            ans:
              <Fragment>
                <p> {"No, " + process.env.REACT_APP_MARCA_BLANCA_DOMAIN + " is not a media outlet. It is a bonus and gaming operator comparator, without regular updates that would qualify it as an editorial product."} </p>
                <p> Our goal is to provide you with transparent information and comparisons of the best promotions and gaming platforms available, always ensuring reliability and security in the operators we recommend.</p>
                <p>Gambling is only for those over 18 years old. Play responsibly.</p>
              </Fragment>
          }
        ]
      }
    }
  },

  navBar: false
}




export default themeConfigGamblingBrasiliaconnect

